// extracted by mini-css-extract-plugin
export var carrierNotice = "_k5-5";
export var carrierNoticePlaceholder = "_k5-6";
export var deliveryRow = "_k5-c";
export var fixedHeight = "_k5-4";
export var freightLogo = "_k5-b";
export var fullWidth = "_k5-3";
export var priceColumn = "_k5-7";
export var radioSelected = "_k5-9";
export var radioUnselected = "_k5-8";
export var selectedOption = "_k5-2";
export var selectedOptionContainer = "_k5-1";
export var selection = "_k5-0";
export var tallSkeletonText = "_k5-a";